<template>
  <div class="rejection-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>拒收单号:</label>
            <lk-input clearable v-model='query.code' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>供应商:</label>
            <SupplierListSelect v-model="query.supplierId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>成本类型:</label>
            <lk-select v-model='query.payment' class="item">
              <lk-option v-for="(item, index) in paymentType" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源单据:</label>
            <lk-select v-model='query.purchaseRejectionType' class="item">
              <lk-option v-for="(item, index) in sourceType" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';


export default {
  name: 'rejection',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
  },
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      paymentType: ['普通', '寄售'],
      sourceType: ['收货单', '验收单'],
      query: {
        code: '',
        status: '',
        // createUserName: null,
        // createTimeStart: null,
        createTimeEnd: '',
        supplierId: null,
        payment: '',
        purchaseType: 1,
      },
      columns: [
        { title: '上级单据', key: 'typeName', minWidth: 116 },
        { title: '拒收单号', key: 'code', minWidth: 116 },
        { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        {
          title: '商品类型', key: 'goodsTypeName', width: 116,
        },
        {
          title: '来源', key: 'purchaseTypeName', width: 116,
        },
        { title: '成本类型', key: 'paymentName', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        {
          title: '操作',
          minWidth: 116,
          key: 'operation',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'rejectionInfo',
                    params: { purchaseRejectionId: params.row.id },
                  });
                },
              },
            }, '查看'),

          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.query = {
        code: '',
        status: '',
        createUserName: '',
        // createTimeStart: null,
        // createTimeEnd: null,
        supplierId: null,
        payment: '',
        storeIdList: [],
        goodsType: null,
        purchaseType: null,
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // if (this.params.createTimeStart) {
      //   this.params.createTimeStart = (new Date(this.params.createTimeStart)).getTime();
      // }
      // if (this.params.createTimeEnd) {
      //   this.params.createTimeEnd = (new Date(this.params.createTimeEnd)).getTime();
      // }
      purchase.rejectionList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.formatTime(result.createTime, 'YYYY/MM/DD HH:mm');
            result.typeName = this.sourceType[result.type - 1];
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>

</style>
